import React from 'react'
import { Link } from 'react-router-dom'
// CSS
import '../assets/css/links-map.css'

export default function LinksMap(props) {

  const linksArr = props.linksArr;

  return (
    <div className='links_map'>
      <div className='map'>
        {
          linksArr.map((link, index) => {
            return(
              linksArr.length === (index+1) ? 
              <Link to={link.path} className='active select_n' key={index}>{link.name}</Link>
              :
              linksArr.length !== (index+1) && link.active === true ?
              <>
               <Link className='active select_n' to={link.path} key={index}>{link.name}</Link>
               <span className='fas fa-arrow-right select_n'></span>
              </>
              :
              <>
               <Link className='select_n' to={link.path} key={index}>{link.name}</Link>
               <span className='fas fa-arrow-right select_n'></span>
              </>
            )
          })
        }
      </div>
      <div className='title select_n'>{props.pageName}</div>
    </div>
  )
}
